import React from "react";

import { CustomFieldGroupsTableActions } from "./CustomFieldGroupsTableActions";

export const getCustomFieldGroupsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 80,
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Custom Fields",
      id: "Custom Fields",
      accessorKey: "custom_field_configs",
      cell: ({ row }) => {
        const value = row.original.custom_field_configs || [];
        return value.map(item => item.label).join(", ");
      },
    },
    {
      header: "Model Type",
      id: "Model Type",
      accessorKey: "model_type",
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <CustomFieldGroupsTableActions original={row.original} />
      ),
    },
  ];
};

export const getCustomFieldGroupsTableFilters = () => {
  return [];
};
